import React from "react";

function ActiveImeiBarcodeIcon({fill}) {
  return (
    <>
      <svg
        width="21"
        height="13"
        viewBox="0 0 21 13"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M0 12.923V0H1.846V12.923H0ZM2.76925 12.923V0H4.61525V12.923H2.76925ZM5.5385 12.923V0H6.4615V12.923H5.5385ZM8.30752 12.923V0H10.1537V12.923H8.30752ZM11.0767 12.923V0H13.846V12.923H11.0767ZM14.769 12.923V0H15.6922V12.923H14.769ZM17.5382 12.923V0H20.3075V12.923H17.5382Z"
          fill={fill}
        />
      </svg>
    </>
  );
}

export default ActiveImeiBarcodeIcon;
